/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const REBATE_PROGRAM = 'Rebate Program';
export const PLAN_TYPE = 'Plan Type';
export const navigateSearch = '/cmsRosi';
export const navigateDetails = '/cmsRosiDetails';
export const ALL_AUDIT_TYPES = 'All Audit Types';
export const NO_DATA_FOUND = 'There is no data to display.';
export const LOADING = 'Loading...';
export const CMS_ROS_DISCREPANCY = 'CMS ROSI Discrepancy';
export const DOUBLE_CLICK =
  '* On Double Click of Results, system should navigate to Detail page';
export const CMS_ROSI_MANUFACTURE = 'CMS ROSI-Manufacturer';
